import React, { useCallback } from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import {
    HrMappingValue,
    HrPositionMapping,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/type';
import { Box } from '@mui/material';

import {
    PutPositionMappingPayload,
    usePutPositionMapping,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/hooks/hrPositionMapping';
import {
    IndiciaireEnum,
    RecurrenceEnum,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { StySwitch } from 'ui/Switch/Switch';

type CustomParams = {
    fieldToUpdate: keyof PutPositionMappingPayload;
    valueChecked: IndiciaireEnum | RecurrenceEnum;
    valueUnchecked: IndiciaireEnum | RecurrenceEnum;
};

type Props = CellRendererParams<HrPositionMapping, HrMappingValue | null> &
    CustomParams;

function HrMappingToggleCellRenderer({
    value,
    data,
    fieldToUpdate,
    valueChecked,
    valueUnchecked,
}: Props) {
    const updateMappingMutation = usePutPositionMapping();
    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = event.target.checked
                ? valueChecked
                : valueUnchecked;
            updateMappingMutation.mutate({
                [fieldToUpdate]: newValue,
                // TODO: try to remove this non-null assertion
                hrPositionMappingIds: [data!.id],
            });
        },
        [JSON.stringify(data), updateMappingMutation],
    );

    const isChecked = value === valueChecked;

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100%"
        >
            <StySwitch
                checked={isChecked}
                onChange={handleChange}
                color="primary"
            />
        </Box>
    );
}

export default HrMappingToggleCellRenderer;
